.btn {
  position: relative;
  color: inherit;
  display: inline-flex;
  font-weight: 400;
  white-space: nowrap;
  user-select: none;
  text-transform: none;
  overflow: visible;
  font-family: var(--font-main);
  text-decoration: none;
  cursor: pointer;
  border: thin solid transparent;
  outline: none;
  align-items: center;
  justify-content: center;
  border-radius: var(--border-radius-secondary);
  line-height: 1;

  :global(.cw-icon) {
    font-size: 2.4rem;
  }

  /* todo http://lesscss.org/functions/#list-functions-each */

  &:not(.btnSilent):focus {
    box-shadow: 0 0 0.4rem var(--color-neutral-lightest);
    border-color: var(--color-black);
  }

  &.btnWithoutPaddings {
    padding: 0;
  }

  a {
    color: inherit;
    text-decoration: none;
  }
}

.btnImage {
  .btnContentWrapper {
    justify-content: center;
  }

  img {
    width: 80%;
    height: 80%;
  }
}

.btnXl {
  padding: 0.6rem 1.8rem;
  font-size: 1.6rem;
  height: 5.4rem;
}

.btnXl.btnIcon {
  font-size: 3.6rem;
  width: 5.4rem;
  padding: 0.2rem 0.4rem;

  :global(.cw-icon) {
    font-size: 3.6rem;
  }
}

.btnXl.btnImage {
  width: 5.4rem;
  padding: 0;
}

.btnM {
  padding: 0.6rem 1.8rem;
  font-size: 1.6rem;
  height: 3.6rem;
}

.btnM.btnIcon {
  font-size: 2.4rem;
  width: 3.6rem;
  padding: 0.2rem 0.4rem;

  :global(.cw-icon) {
    font-size: 2.4rem;
  }
}

.btnM.btnImage {
  width: 3.6rem;
  padding: 0;
}

.btnMl {
  padding: 0.6rem 1.8rem;
  font-size: 1.6rem;
  height: 4.4rem;
}

.btnMl.btnIcon {
  font-size: 2.5rem;
  width: 4.4rem;
  padding: 0.2rem 0.4rem;

  :global(.cw-icon) {
    font-size: 2.5rem;
  }
}

.btnMl.btnImage {
  width: 4.4rem;
  padding: 0;
}

.btnS {
  padding: 0.4rem 2.2rem;
  font-size: 1rem;
  height: 2.4rem;

  :global(.cw-icon) {
    font-size: 1.6rem;
  }
}

.btnS.btnIcon {
  width: 2.4rem;
  font-size: 1.6rem;
  padding: 0.2rem 0.4rem;

  :global(.cw-icon) {
    font-size: 1.6rem;
  }
}

.btnS.btnImage {
  width: 2.4rem;
  padding: 0;
}

.btnXs {
  padding: 0.1rem 0.4rem;
  font-size: 1.4rem;
  height: 2rem;

  :global(.cw-icon) {
    font-size: 1.4rem;
  }
}

.btnXs.btnIcon {
  width: 2rem;

  :global(.cw-icon) {
    font-size: 1.4rem;
  }
}

.btnXs.btnImage {
  width: 2rem;
}

.btnBlock {
  display: flex;
  width: 100%;
}

.btn:disabled,
.btnDisabled {
  opacity: 0.5;
  pointer-events: none;
}

.btnSilent {
  cursor: default;
}

.btnTextEllipsis {
  span {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: inline;
    line-height: normal;
  }
}

.btnContentWrapper {
  display: inline-flex;
  align-items: center;
}

.buttonIconLeft {
  > :global(.cw-icon) {
    margin-right: 1rem;
  }
}

.buttonIconRight {
  > :global(.cw-icon) {
    margin-left: 1rem;
  }
}

.buttonDefault {
  background-color: var(--color-neutral);
  color: var(--color-white);

  &:not(.btnSilent):hover {
    background-color: var(--color-grey-7);
  }

  &:not(.btnSilent):active {
    background-color: #1f1f1f;
  }

  &.btnActive {
    &.btnActiveDefault {
      background-color: var(--color-white);
      color: var(--color-black);

      &.btnDisabledDeep {
        background-color: var(--color-grey-13);
      }
    }

    &.btnActivePrimary {
      background-color: var(--color-primary);
      color: var(--color-white);
    }

    &.btnActiveAmbient {
      background-color: var(--color-grey-6);
      color: var(--color-white);

      &:focus {
        box-shadow: none;
        border-bottom-color: transparent;
      }
    }
  }

  &.btnDisabled {
    &.btnDisabledDeep {
      opacity: 1;
      color: var(--color-grey-7);
    }
  }
}

.buttonPrimary {
  background-color: var(--color-primary);
  color: var(--color-white);

  &:not(.btnSilent):hover {
    /* #4A72FF; */
    background-color: #4a72ff;
  }

  &.btnActive {
    /* #2342B2; */
    background-color: #2353ff;
  }
}

.buttonSecondary {
  background-color: var(--color-secondary);
  color: var(--color-black);

  &:not(.btnSilent):hover {
    background: #ebc39d;
  }

  &.btnActive {
    background-color: #9e7c5b;
  }
}

.buttonTertiary {
  background-color: var(--color-tertiary);
  color: var(--color-white);

  &:not(.btnSilent):hover {
    background: #ff6e6e;
  }

  &.btnActive {
    background-color: #bf3636;
  }
}

.buttonQuaternary {
  background-color: var(--color-warning);
  color: var(--color-black);

  &:not(.btnSilent):hover {
    background: #f5d77a;
  }

  &.btnActive {
    background-color: #eeba1b;
  }
}

.buttonAccent {
  background-color: var(--color-accent);
  color: var(--color-white);

  &:not(.btnSilent):hover {
    background: #66d994;
  }

  &.btnActive {
    background-color: #2d8c53;
  }
}

.buttonGhost {
  background-color: transparent;
  outline: none;
  box-shadow: none;
  opacity: 0.8;

  &:not(.btnSilent):hover {
    opacity: 1;
  }

  &.btnActive {
    opacity: 1;
    background-color: var(--color-white);
    color: var(--color-black);
  }

  &:disabled,
  &.btnDisabled {
    opacity: 0.2;
  }
}

.buttonGhostWarning {
  background-color: transparent;
  outline: none;
  box-shadow: none;
  color: var(--color-tertiary);

  &:disabled,
  &.btnDisabled {
    opacity: 0.2;
  }
}

.buttonTransparent {
  background-color: transparent;
  outline: none;
  box-shadow: none;
  -webkit-tap-highlight-color: transparent;

  &:disabled,
  &.btnDisabled {
    opacity: 0.2;
  }

  &:not(.btnSilent):focus {
    box-shadow: none;
    border-color: transparent;
  }

  &.btnActive {
    &.btnActiveLightest {
      background-color: var(--color-neutral-lightest);
      color: var(--color-black);
    }
  }
}

.buttonTransparentHoverable {
  background-color: transparent;
  outline: none;
  box-shadow: none;
  -webkit-tap-highlight-color: transparent;

  &:disabled,
  &.btnDisabled {
    opacity: 0.2;
  }

  &:not(.btnSilent):focus {
    box-shadow: none;
    border-color: transparent;
  }

  &.btnActive {
    &.btnActiveLightest {
      background-color: var(--color-neutral-lightest);
      color: var(--color-black);
    }
  }

  &:hover {
    background-color: var(--color-grey-7);
  }
}

.buttonBordered {
  background-color: transparent;
  outline: none;
  box-shadow: none;
  -webkit-tap-highlight-color: transparent;
  border: thin solid var(--color-neutral);
  color: var(--color-black);

  &:disabled,
  &.btnDisabled {
    opacity: 0.2;
  }

  &.btnActive {
    background-color: var(--color-white);
  }
}

.buttonNeutralNotSoLight {
  background-color: var(--color-neutral-not-so-light);
  outline: none;
  box-shadow: none;
  -webkit-tap-highlight-color: var(--color-neutral-not-so-light);
  color: var(--color-white);

  &:disabled,
  &.btnDisabled {
    opacity: 0.2;
  }
}

.buttonInert {
  background-color: rgb(0, 0, 0, 0.5);
  outline: none;
  box-shadow: none;
  color: var(--color-white);

  &:hover {
    background-color: var(--color-grey-7);
  }
}

.btn.buttonWhite {
  background-color: var(--color-white);
  outline: none;
  box-shadow: none;
  color: var(--color-black);

  &:hover {
    background-color: var(--color-bg-secondary-light);
  }

  &.btnActive {
    background-color: var(--color-primary);
    color: var(--color-white);
  }

  &:not(.btnSilent):focus {
    border-color: transparent;
    box-shadow: none;
  }
}

.btn.buttonLink {
  height: auto;
  padding: 0;
  border: none;
  border-radius: 0;
  background-color: transparent;
  font-size: 1.4rem;
  line-height: 1.4;
  color: var(--color-white);
  white-space: normal;
  text-decoration: underline;
  text-decoration-color: var(--color-neutral-light);
  text-underline-offset: 0.3rem;

  &:hover {
    text-decoration-color: var(--color-white);
  }

  &:not(.btnSilent):focus {
    border-color: transparent;
    box-shadow: none;
  }
}

.buttonTextColorDark {
  color: var(--color-black);
}

.buttonTextColorLight {
  color: var(--color-white);
}

.btnHideChildren {
  visibility: hidden;
}

.btnLoading {
  pointer-events: none;
}

.btnLoader {
  position: absolute;
}

.btnWide {
  min-width: 20rem;
}
